module.exports = __webpack_public_path__ + "img/31.51b24dc7.png";